export const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

export const aadhaarFrontendPattern = /^[2-9]\d{3}\s?\d{4}\s?\d{4}$/;

export const vehicleFrontendPattern =
  /^(?:[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\d{1,4}|\d{2}\s?BH\s?\d{4}\s?[A-Z]{2})$/;
